export const asyncLoadImage = async ( url, elem, srcSet ) => {
	return new Promise( ( resolve, reject ) => {
		elem.onload = () => resolve( elem );
		elem.onerror = reject;
		elem.src = url;

		if ( srcSet ) {
			const { dpi2x, dpi1x } = srcSet;
			elem.src = `${url}${dpi1x}`;
			elem.srcset = `${url}${dpi1x} 1x, ${url}${dpi2x} 2x`;
		}
	} );
};

export default asyncLoadImage;
